import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Account created");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="register-page">
      <div className="label-eyebrow mb-3">Create Account</div>
      <h1 className="font-serif-display text-4xl text-white">Join <span className="italic text-[#D4AF37]">HOH_Vibes</span></h1>
      <form onSubmit={submit} className="mt-10 space-y-4">
        <div>
          <label className="text-xs tracking-widest uppercase text-neutral-400">Name</label>
          <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)} className="mt-2 w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-4 py-3 rounded text-white" />
        </div>
        <div>
          <label className="text-xs tracking-widest uppercase text-neutral-400">Email</label>
          <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-4 py-3 rounded text-white" />
        </div>
        <div>
          <label className="text-xs tracking-widest uppercase text-neutral-400">Password</label>
          <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-4 py-3 rounded text-white" />
        </div>
        <button data-testid="register-submit" disabled={loading} className="btn-gold w-full py-3 rounded text-sm tracking-widest uppercase font-semibold">
          {loading ? "Creating..." : "Create Account"}
        </button>
      </form>
      <p className="text-sm text-neutral-400 mt-6 text-center">
        Already have an account? <Link to="/login" className="text-[#D4AF37] hover:text-[#FCE68A]">Sign in</Link>
      </p>
    </div>
  );
}
